<template>
	<!-- 我的评价 ,当前页面废弃-->
	<div class="evaluate">
		<div class="form">
			<p>评论人信息:</p>
			<div class="people">
				<img :src="imgUrl + info.heading" alt="">
				<span>{{info.masterName}}</span>
			</div>
			<p>评论内容:</p>
			<div class="content">
				<img :src="$imgUrl + info.proposalUrl" alt="">
				<div>{{info.proposal}}</div>
			</div>
			<div class="repl" v-if="$route.query.type == 1">
				<textarea v-model="form.estimate" :rows="5" placeholder="请输入回复内容"></textarea>
				<el-button type="primary" size="medium" @click="submit">提交</el-button>
			</div>
			<div class="repl-content" v-else>
				<p>回复内容:</p>
				<div>{{info.estimate}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		equOrderDetail,
		updateOrder
	} from '../../http/factory/add-eme.js';
	export default {
		name: 'evaluate',
		data() {
			return {
				form: {
					estimate: ''
				},
				info: {}
			};
		},
		created() {
			this.getDetail()
		},
		methods: {
			getDetail() {
				equOrderDetail({
					id: this.$route.query.orderId
				}).then(res => {
					this.info = res
				})
			},
			submit() {
				updateOrder({
					id: this.info.id,
					estimate: this.form.estimate
				}).then(res => {
					this.$message({
						type: 'success',
						message: '回复成功'
					})
				})
				this.$router.go(-1)
			}
		}
	};
</script>

<style lang="less" scoped="scoped">
	.evaluate {
		width: 100%;
		background: @vue-bg-color;

		.form {
			background-color: #fff;
			min-height: 800px;
			width: 100%;
			padding: 20px;
			font-size: 20px;

			p {
				font-size: 20px;
				color: #5f5f5f;
			}

			.people {
				display: flex;
				align-items: center;
				padding: 20px 0;

				img {
					width: 50px;
					height: 50px;
					margin-right: 20px;
				}
			}

			.content {
				padding: 20px 0;

				img {
					width: 150px;
					height: 150px;
				}

				div {
					margin: 20px 0;
					min-height: 50px;
				}
			}

			.repl {
				padding: 20px 0;
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				min-height: 150px;
				justify-content: space-between;

				textarea {
					border: 1px solid #cecece;
					width: 100%;
				}

				textarea:focus-visible {
					outline: 1px solid #cecece;
				}

				el-button {}
			}

			.repl-content {
				padding: 20px 0;

				div {
					margin-top: 20px;
				}
			}

		}
	}
</style>
